const header = document.querySelector("header");
const menuMob = document.querySelector("#menuMob");
const toggleMenu = document.querySelector("#toggleMenu");
const htmlOpen = document.documentElement;

let headerHeight = header ? header.offsetHeight : 0;
const sectionOffset = 32;

function updateHeaderHeight() {
	headerHeight = header ? header.offsetHeight : 0;
}

function closeMobileMenu() {
	if (!menuMob || !toggleMenu) {
		return;
	}

	menuMob.classList.remove("open");
	htmlOpen.classList.remove("menu-active");
	toggleMenu.classList.remove("active");
	toggleMenu.setAttribute("aria-expanded", "false");
	toggleMenu.setAttribute("aria-label", "Abrir menu");
}

function setHeaderSticky() {
	if (!header) {
		return;
	}

	header.classList.toggle("fixed", window.scrollY > 0);
}

let ticking = false;
function handleStickyOnScroll() {
	if (ticking) {
		return;
	}

	ticking = true;
	requestAnimationFrame(() => {
		setHeaderSticky();
		ticking = false;
	});
}

function scrollToSection(event) {
	const link = event.target.closest('a[href^="#"]');
	if (!link) {
		return;
	}

	const href = link.getAttribute("href");
	if (!href || href === "#") {
		return;
	}

	const section = document.querySelector(href);
	if (!section) {
		return;
	}

	event.preventDefault();
	updateHeaderHeight();

	const offsetTop = section.offsetTop - headerHeight + sectionOffset;
	window.scrollTo({
		top: Math.max(0, offsetTop),
		behavior: "smooth",
	});

	closeMobileMenu();
}

function openMenuMobile(event) {
	if (event) {
		event.preventDefault();
	}

	if (!menuMob || !toggleMenu) {
		return;
	}

	const isOpen = !menuMob.classList.contains("open");
	menuMob.classList.toggle("open");
	htmlOpen.classList.toggle("menu-active");
	toggleMenu.classList.toggle("active");
	toggleMenu.setAttribute("aria-expanded", String(isOpen));
	toggleMenu.setAttribute("aria-label", isOpen ? "Fechar menu" : "Abrir menu");
}

function handleKeyboardNavigation(event) {
	if (event.key === "Escape") {
		closeMobileMenu();
	}
}

window.addEventListener("scroll", handleStickyOnScroll, { passive: true });
window.addEventListener("resize", updateHeaderHeight, { passive: true });
window.addEventListener("keydown", handleKeyboardNavigation);
document.addEventListener("click", scrollToSection);

window.openMenuMobile = openMenuMobile;
window.openMenuMob = openMenuMobile;

updateHeaderHeight();
setHeaderSticky();

if (typeof window.initGsapAnimations === "function") {
	window.initGsapAnimations();
}
